<template>
<!-- :xs="8" :sm="6" :md="4" :lg="3"  -->
    <span id="services">
        <el-row :gutter="20">
            <el-col :xs="24" ><h1 style="font-size: 35px !important" class="chevere-title">Servicios</h1></el-col>
        </el-row>
        <el-row class="hidden-sm-and-down" :gutter="20">
            <el-col :md="12" :lg="8">
                <router-link to='/servicio/soluciones-web' style="text-decoration:none" >
                    <div class="text item">
                        <img class="chevere-img" src="@/../public/assets/images/services/Servicios 1.png" alt="Soluciones Web" title="Soluciones Web">
                        <h3 class="service-text">Soluciones Web</h3>
                    </div>                    
                </router-link> 
            </el-col>

            <el-col :md="12" :lg="8">
                <a target="_blank" href="https://hosting.chevere.tech/" style="text-decoration:none" >
                    <div class="text item">                            
                        <img class="chevere-img" src="@/../public/assets/images/services/Servicios 4.png" alt="Dominios y hosting" title="Dominios y hosting">  
                        <h3 class="service-text">Dominios y hosting</h3>                                                             
                    </div>                    
                </a>                
            </el-col>

            <el-col :md="12" :lg="8">
                <router-link to='/servicio/desarrollos-de-aplicaciones' style="text-decoration:none" >
                    <div class="text item">
                        <img class="chevere-img" src="@/../public/assets/images/services/Servicios 3.png" alt="Desarrollo de aplicaciones" title="Desarrollo de aplicaciones">
                        <h3 class="service-text">Desarrollo de aplicaciones</h3>                                                               
                    </div>                   
                </router-link>                
            </el-col>

            <el-col :md="12" :lg="8">
                <router-link to='/servicio/optimizacion-de-procesos' style="text-decoration:none" >
                    <div class="text item">                            
                        <img class="chevere-img" src="@/../public/assets/images/services/Servicios 6.png" alt="Optimización de Procesos" title="Optimización de Procesos">   
                        <h3 class="service-text">Optimización de Procesos</h3>
                    </div>                    
                </router-link>               
            </el-col>
            <el-col :md="12" :lg="8">
                <router-link to='/servicio/outsourcing' style="text-decoration:none" >                    
                    <div class="text item">                            
                        <img class="chevere-img" src="@/../public/assets/images/services/Servicios 2.png" alt="Redes" title="Outsourcing">                                                              <h3 class="service-text">Outsourcing Informático</h3> 
                    </div>                    
                </router-link>                 
            </el-col>
            <el-col :md="12" :lg="8">
                <router-link to='/servicio/facturacion' style="text-decoration:none" >                   
                    <div class="text item">                            
                        <img class="chevere-img" src="@/../public/assets/images/services/Servicios 5.png" alt="Facturación Electronica" title="Facturación Electronica">  
                        <h3 class="service-text">Facturación Electronica</h3>
                    </div>                   
                </router-link>                 
            </el-col>
        </el-row>
        <el-row :gutter="20" class="hidden-md-and-up">
            <Carousel   
                    :per-page="1" 
                    :mouse-drag="true"
                    :autoplay="true"
                    :loop="true"
                    :paginationEnabled="false">
                <Slide>
                    <el-row :gutter="20">
                        <el-col :xs="24" >
                            <router-link to='/servicio/soluciones-web' style="text-decoration:none" >
                                <div class="text item">
                                    <img class="chevere-img" src="@/../public/assets/images/services/Servicios 1.png" alt="Soluciones Web" title="Soluciones Web">
                                    <h3 class="service-text">Soluciones Web</h3>
                                </div>      
                            </router-link> 
                        </el-col> 
                    </el-row>
                </Slide>
                <Slide>
                    <el-row :gutter="20">
                        <el-col :xs="24" >
                            <a target="_blank" href="https://hosting.chevere.tech/" style="text-decoration:none" >
                                <div class="text item">                            
                                    <img class="chevere-img" src="@/../public/assets/images/services/Servicios 4.png" alt="Dominios y hosting" title="Dominios y hosting">  
                                    <h3 class="service-text">Dominios y hosting</h3>                                                             
                                </div>   
                            </a> 
                        </el-col> 
                    </el-row>
                </Slide>    
                <Slide>
                    <el-row :gutter="20">
                        <el-col :xs="24" >
                            <router-link to='/servicio/desarrollos-de-aplicaciones' style="text-decoration:none" >
                                <div class="text item">
                                    <img class="chevere-img" src="@/../public/assets/images/services/Servicios 3.png" alt="Desarrollo de aplicaciones" title="Desarrollo de aplicaciones">
                                    <h3 class="service-text">Desarrollo de aplicaciones</h3>                                                               
                                </div>
                            </router-link>
                        </el-col>   
                    </el-row>
                </Slide>  
                <Slide>
                    <el-row :gutter="20">
                        <el-col :xs="24" >
                            <router-link to='/servicio/optimizacion-de-procesos' style="text-decoration:none" >
                                <div class="text item">                            
                                    <img class="chevere-img" src="@/../public/assets/images/services/Servicios 6.png" alt="Optimización de Procesos" title="Optimización de Procesos">   
                                    <h3 class="service-text">Optimización de Procesos</h3>
                                </div>
                            </router-link> 
                        </el-col>   
                    </el-row>
                </Slide>       
                <Slide>
                    <el-row :gutter="20">
                        <el-col :xs="24" >
                            <router-link to='/servicio/outsourcing' style="text-decoration:none" >
                                <div class="text item">                            
                                    <img class="chevere-img" src="@/../public/assets/images/services/Servicios 2.png" alt="Redes" title="Outsourcing">                                                      <h3 class="service-text">Outsourcing Informático</h3> 
                                </div>
                            </router-link>  
                        </el-col>   
                    </el-row>
                </Slide>  
                <Slide>
                    <el-row :gutter="20">
                        <el-col :xs="24" >
                            <router-link to='/servicio/facturacion' style="text-decoration:none" >
                                <div class="text item">                            
                                    <img class="chevere-img" src="@/../public/assets/images/services/Servicios 5.png" alt="Facturación Electronica" title="Facturación Electronica">  
                                    <h3 class="service-text">Facturación Electronica</h3>
                                </div> 
                            </router-link>  
                        </el-col>   
                    </el-row>
                </Slide>                
            </Carousel>
        </el-row>
    </span>
</template>

<script>
import { Carousel, Slide } from 'vue-carousel';

export default {
    name: "servicios",
    components: {
        Carousel,
        Slide
    }
}
</script>

<style scoped>
    .item{
        margin-top:20px;
    }
    .chevere-img{
        max-width: 150px;
        max-height: 150px;    
    }
    .service-text{
        padding-top: 15px;
        color:#3d8e95;
    }
    .box-card{
        height: auto;  
        transition: transform .3s;      
    }
    .box-card:hover{
        transform: scale(1.05);
    }
</style>





// WEBPACK FOOTER //
// src/sections/Servicios.vue